import { render, staticRenderFns } from "./SourceRatingImportPage.vue?vue&type=template&id=0b22448f"
import script from "./SourceRatingImportPage.vue?vue&type=script&lang=js"
export * from "./SourceRatingImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports